"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderHelp = exports.CoreHeaderHelp = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var Overlay_1 = require("../Overlay");
exports.CoreHeaderHelp = function (_a) {
    var _b;
    var className = _a.className, items = _a.items, onMenuItemClick = _a.onMenuItemClick, disableDropdown = _a.disableDropdown, onHelpClicked = _a.onHelpClicked, helpRedirectUrl = _a.helpRedirectUrl;
    var _c = tslib_1.__read(react_1.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var classNames = classnames_1.default((_b = {
            "gd-header-help": true,
            "gd-icon-header-help": true,
            "is-open": isOpen && !helpRedirectUrl,
            "anchor-tag-header-help": !isEmpty_1.default(helpRedirectUrl)
        },
        _b[className] = !!className,
        _b));
    var menuItems = items.map(function (item) {
        return (react_1.default.createElement("a", { key: item.key, href: item.href, target: item.target, rel: item.target === "_blank" ? "noreferrer noopener" : undefined, onClick: function () {
                menuItemClicked(item);
            }, className: "gd-list-item " + item.className },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: item.key })));
    });
    var toggleHelpMenu = function (isMenuOpen) {
        if (isMenuOpen === void 0) { isMenuOpen = !isOpen; }
        onHelpClicked && onHelpClicked(isMenuOpen);
        setIsOpen(isMenuOpen);
    };
    var menuItemClicked = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        toggleHelpMenu(false);
        onMenuItemClick.apply(void 0, tslib_1.__spread(args));
    };
    var renderHelpMenu = function () {
        return isOpen ? (react_1.default.createElement(Overlay_1.Overlay, { alignTo: ".gd-header-help", alignPoints: [
                {
                    align: "br tr",
                },
            ], closeOnOutsideClick: true, closeOnMouseDrag: true, closeOnParentScroll: true, onClose: function () {
                toggleHelpMenu(false);
            } }, !disableDropdown ? (react_1.default.createElement("div", { className: "gd-dialog gd-dropdown overlay gd-header-help-dropdown" },
            react_1.default.createElement("div", { className: "gd-list small" }, menuItems))) : null)) : (false);
    };
    return helpRedirectUrl ? (react_1.default.createElement("a", { className: classNames, href: helpRedirectUrl, target: "_blank", rel: "noreferrer noopener" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.header.help" }))) : (react_1.default.createElement("div", { className: classNames, onClick: function () { return toggleHelpMenu(); } },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.header.help" }),
        renderHelpMenu()));
};
exports.HeaderHelp = react_intl_1.injectIntl(exports.CoreHeaderHelp);
//# sourceMappingURL=HeaderHelp.js.map